module.exports = __webpack_public_path__ + "img/quotes.d598fab5.svg";